module.exports = __webpack_public_path__ + "img/success.8d5570d9.png";